export default __webpack_public_path__ + "static/media/banner5.0b3d1fff.png";